import { render, staticRenderFns } from "./hotmart-app.vue?vue&type=template&id=73e4b71d"
import script from "./hotmart-app.vue?vue&type=script&lang=js"
export * from "./hotmart-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports